import { render, staticRenderFns } from "./FormFeedback.vue?vue&type=template&id=6ca9f65e&"
import script from "./FormFeedback.vue?vue&type=script&lang=ts&"
export * from "./FormFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca9f65e')) {
      api.createRecord('6ca9f65e', component.options)
    } else {
      api.reload('6ca9f65e', component.options)
    }
    module.hot.accept("./FormFeedback.vue?vue&type=template&id=6ca9f65e&", function () {
      api.rerender('6ca9f65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/form/FormFeedback.vue"
export default component.exports